import React, { useEffect, useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Table from 'react-bootstrap/Table';
import useAxiosProtect from '../../../../../../hooks/useAxiosProtect';

const SensorCalibrationHistory = props => {
    const axiosProtect = useAxiosProtect();
    const [calibrationHistory, setCalibrationHistory] = useState([]);
    const [serverError, setServerError] = useState('');

    const closeModal = () => {
        props.setSelectedSensor(null);
        setCalibrationHistory([]);
        setServerError('');
    };

    const formatUTCDate = dateString => new Date(dateString).toLocaleString('en-CA', {
        timeZone: 'UTC',
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }) + ' UTC';

    useEffect(() => {
        if(props.selectedSensor == null) return;

        const controller = new AbortController();
        const sensorId = props.selectedSensor.sensor_id || props.selectedSensor.id;

        setCalibrationHistory([]);
        setServerError('');

        axiosProtect.get(`/v2s/v2-sensors/calibration-history?sensor_id=${sensorId}`, {
            signal: controller.signal
        }).then(response => {
            setCalibrationHistory(response.data.history);
        }).catch(error => {
            if(error.name !== 'CanceledError'){
                setServerError(error.response?.data?.error || 'Unable to load calibration history');
            }
        });

        return () => controller.abort();
    }, [props.selectedSensor]);

    return (
        <Modal
            show={props.selectedSensor != null}
            onHide={closeModal}
            backdrop="static"
            centered
            className="opp-modal-root"
            backdropClassName="opp-modal-backdrop"
            dialogClassName="opp-modal-cw"
        >
            <Modal.Header closeButton>
                <span><strong>{props.selectedSensor?.name}</strong> calibration history</span>
            </Modal.Header>

            <Modal.Body>
                {serverError !== '' && <p style={{color: 'red', textAlign: 'center'}}>{serverError}</p>}

                {serverError === '' && calibrationHistory.length === 0 && (
                    <p style={{textAlign: 'center'}}>No calibration history available</p>
                )}

                {calibrationHistory.length > 0 && (
                    <Table>
                        <thead>
                            <tr>
                                <th style={{textAlign: 'center'}}>Calibration factor</th>
                                <th style={{textAlign: 'center'}}>Date added</th>
                            </tr>
                        </thead>
                        <tbody>
                            {calibrationHistory.map(entry => (
                                <tr key={entry.id}>
                                    <td style={{textAlign: 'center'}}>{entry.calibration_factor}</td>
                                    <td style={{textAlign: 'center'}}>{formatUTCDate(entry.date_created)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default SensorCalibrationHistory;
